import React, { useSyncExternalStore } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { useSelector } from 'react-redux'
import { EtuoviReactEmbed } from '@almamedia/alma-embeds/dist/etuovi'
import { NettiautoColumnEmbed } from '@almamedia/alma-embeds/dist/nettiauto-column'
import { ILUutisboksi } from '@almamedia/alma-embeds/dist/il-uutisboksi'
import { KLUutisboksi } from '@almamedia/alma-embeds/dist/kl-uutisboksi'
import { selectIsNightModeEnabled, selectUserABTestVariant } from '../../selectors/userSelector'
import {
  selectTrafficSteeringBrand,
  selectTrafficSteeringIlCategories,
} from '../../selectors/trafficSteeringSelector'
import {
  BRAND_ETUOVI,
  BRAND_ILTALEHTI,
  BRAND_KAUPPALEHTI,
  BRAND_NETTIAUTO,
} from '../../lib/trafficSteering'
import './traffic-steering.pcss'

const UTM_SOURCE = 'ampparit'

/** Embeds touch window on mount, so they must not render during SSR. */
const subscribeToNothing = () => () => {}
const isClient = () => true
const isServer = () => false

function PartnerEmbed({ brand, nightMode, ilCategories }) {
  switch (brand) {
    case BRAND_ETUOVI:
      return <EtuoviReactEmbed utmSource={ UTM_SOURCE } />
    case BRAND_NETTIAUTO:
      return <NettiautoColumnEmbed utmSource={ UTM_SOURCE } />
    case BRAND_ILTALEHTI:
      return (
        <ILUutisboksi
          utmSource={ UTM_SOURCE }
          darkThemeEnabled={ nightMode }
          { ...(ilCategories ? { categories: ilCategories } : {}) }
        />
      )
    case BRAND_KAUPPALEHTI:
      return <KLUutisboksi utmSource={ UTM_SOURCE } />
    default:
      return null
  }
}

PartnerEmbed.propTypes = exact({
  brand: PropTypes.string.isRequired,
  nightMode: PropTypes.bool.isRequired,
  ilCategories: PropTypes.arrayOf(PropTypes.string),
})

/**
 * Contextual Alma partner box. Renders only when the A/B variant matches `placement`
 * and the current page maps to a target brand.
 */
const TrafficSteeringBox = ({ placement }) => {
  const variant = useSelector(selectUserABTestVariant)
  const brand = useSelector(selectTrafficSteeringBrand)
  const ilCategories = useSelector(selectTrafficSteeringIlCategories)
  const nightMode = useSelector(selectIsNightModeEnabled)
  const canRenderEmbed = useSyncExternalStore(subscribeToNothing, isClient, isServer)

  const visible = Boolean(brand) && variant === placement

  if (!visible || !canRenderEmbed) {
    return null
  }

  return (
    <div className='traffic-steering-box' data-brand={ brand } data-placement={ placement }>
      <PartnerEmbed brand={ brand } nightMode={ nightMode } ilCategories={ ilCategories } />
    </div>
  )
}

TrafficSteeringBox.propTypes = exact({
  placement: PropTypes.oneOf(['a', 'b']).isRequired,
})

export default TrafficSteeringBox
